import { render, staticRenderFns } from "./add2.vue?vue&type=template&id=4023df8e&scoped=true&"
import script from "./add2.js?vue&type=script&lang=js&"
export * from "./add2.js?vue&type=script&lang=js&"
import style0 from "./add2.css?vue&type=style&index=0&id=4023df8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4023df8e",
  null
  
)

export default component.exports